import { type Connector } from '@/types/swagger';
import { http } from 'config';
import { callNextPage } from 'util/callNextPage';

import {
  CONNECTORS_BY_ASSET_ID_URL,
  CONNECTORS_BY_GRID_CONNECTION_ID_URL,
  CONNECTORS_BY_ID_URL,
  CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL,
  CONNECTORS_ONLINE_BY_ASSET_ID_URL,
  CONNECTORS_ONLINE_BY_GRID_CONNECTION_ID_URL,
  CONNECTORS_URL,
} from './endpoints';

// ! This should be handled with a query fn with pagination instead of this, we don't have any type safety here
export const getConnectors = async (pageSize = 999) =>
  callNextPage(`${CONNECTORS_URL}?page_size=${pageSize}`);

export const getConnectorById = async (connectorId: number) =>
  await http.get<Connector>(CONNECTORS_BY_ID_URL(connectorId));

export const getOnlineConnectorsByGridConnectionId = async (
  gridConnectionId: number,
  pageSize = 999
) =>
  await http.get<{ results: Connector[] }>(
    CONNECTORS_ONLINE_BY_GRID_CONNECTION_ID_URL(gridConnectionId),
    { params: { page_size: pageSize } }
  );

// ! Sin uso aparente
export const getConnectorsByGridConnectionId = async (gridConnectionId: number, pageSize = 999) =>
  await http.get<{ results: Connector[] }>(CONNECTORS_BY_GRID_CONNECTION_ID_URL(gridConnectionId), {
    params: { page_size: pageSize },
  });

// ! Sin uso aparente
export const getOnlineConnectorsByAssetId = async (assetId: number, pageSize = 999) => {
  return await http.get<{ results: Connector[] }>(CONNECTORS_ONLINE_BY_ASSET_ID_URL(assetId), {
    params: { page_size: pageSize },
  });
};

export const getConnectorsByAssetId = async (assetId: number, pageSize = 999) => {
  return await http.get<{ results: Connector[] }>(CONNECTORS_BY_ASSET_ID_URL(assetId), {
    params: { page_size: pageSize },
  });
};

export const updateConnector = async (connectorId: number, connector: Partial<Connector>) =>
  await http.patch(CONNECTORS_BY_ID_URL(connectorId), connector);

// ! Esto debería ser una query fn dependiente, sin uso aparente
export const manualFieldsCharge = async ({
  connectorId,
  vehicleNumberPlate,
  odometerValue,
  finalSoc,
}: {
  connectorId: number;
  vehicleNumberPlate: string;
  odometerValue: string;
  finalSoc: number;
}) => {
  return finalSoc
    ? await updateConnector(connectorId, { final_soc: finalSoc })
        .then(
          async () =>
            await http.get(
              CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL(
                connectorId,
                vehicleNumberPlate,
                odometerValue
              )
            )
        )
        .catch((e) => e)
    : await http.get(
        CONNECTORS_MANUAL_FIELDS_START_CHARGE_URL(connectorId, vehicleNumberPlate, odometerValue)
      );
};
